// 경량 클래스 결합 헬퍼(clsx 유사). 문자열/배열/객체(truthy 키) 지원.
export function cn(...args) {
	const out = [];
	for (const a of args) {
		if (!a) continue;
		if (typeof a === "string") out.push(a);
		else if (Array.isArray(a)) {
			const r = cn(...a);
			if (r) out.push(r);
		} else if (typeof a === "object") {
			for (const k in a) if (a[k]) out.push(k);
		}
	}
	return out.join(" ");
}
